import gql from 'graphql-tag'

export const GET_EMPLOYEES = gql`
    query Employees($filter: GetEmployeesInput) {
        employees(filter: $filter)   {
            isSuccessful
            message
            employees {
                userId
                canLogin
                fullname
                gender
                maritalStatus
                address
                email
                employeeIdentifier
                phoneNo
                birthdate
                birthplace
                inactiveCause
                inactiveOn
                language
                driverQualifications
                photograph
                bankAccount
                recruitedAt
                isActive
                isDriver
                isEmployee
                joinOn
                groups {
                    id
                    name
                    vgroups {
                    id
                    name
                    }
                }
                userDocs {
                    fullname
                    userId
                    docType
                    docNumber
                    validUntil
                }
                position {
                    name
                    departmentName
                    structureId
                    unitName
                }
            }
        }
    }`

export const GET_DETAIL_EMPLOYEE = gql`
  query Employee($filter: GetEmployeeInput!) {
  employee(filter: $filter) {
    isSuccessful
    message
    employee {
        userId
        fullname
        gender
        maritalStatus
        address
        email
        employeeIdentifier
        phoneNo
        birthdate
        birthplace
        inactiveCause
        inactiveOn
        language
        driverQualifications
        photograph
        bankAccount
        recruitedAt
        isActive
        isEmployee
        isDriver
        joinOn
        groups {
            id
            name
            vgroups {
            id
            name
            }
        }
        userDocs {
            fullname
            userId
            docType
            docNumber
            validUntil
        }
        position {
            name
            departmentName
            structureId
            unitId
            departmentId
            unitName
        }
        userWorkHistory {
          userWorkHistoryId
          userId
          companyName
          position
          joinedOn
          leftOn
        }
    }
  }
}
`

export const CREATE_EMPLOYEE = gql`
  mutation CreateEmployee($input: CreateEmployeeInput!) {
  createEmployee(input: $input) {
    isSuccessful
    message
    employee {
      userId
    }
  }
}
`

export const UPDATE_EMPLOYEE = gql`
  mutation UpdateEmployee($input: UpdateEmployeeInput!) {
  updateEmployee(input: $input) {
    isSuccessful
    message
  }
}
`

export const IMPORT_EMPLOYEE =gql`
mutation ImportEmployees($input: ImportEmployeeInput!) {
  importEmployees(input: $input) {
    isSuccessful
    message
    importEmployees {
      totalSuccess
      totalFailed
      totalData
      errorFile
    }
  }
}
`

export const SUMMARY_TRIP_DRIVER = gql`
  query SummaryTripDriver($filter: SummaryTripDriverFilter) {
  summaryTripDriver(filter: $filter) {
    isSuccessful
    message
    summaryTripDriver {
      summaryTrips {
        vehicleId
        tripMileage
        startLong
        startLat
        stopLong
        stopLat
        maxSpeed
        vehicle {
          licensePlate
        }
        startTime
        stopTime
        totalHourStart
        totalHourStop
      }
      totalTrip
      totalHourStart
      totalHourStop
      motionStatus
    }
  }
}
`

export const LAST_SUMMARY_TRIP_DRIVER = gql`
  query LastSummaryTripDriver($filter: LastSummaryTripDriverFilter) {
  lastSummaryTripDriver(filter: $filter) {
    isSuccessful
    message
    lastSummaryTripDriver {
      summaryTrips {
        vehicleId
        tripMileage
        startLong
        startLat
        stopLong
        stopLat
        maxSpeed
        vehicle {
          licensePlate
        }
        startTime
        stopTime
        totalHourStart
        totalHourStop
      }
      totalTrip
      totalHourStart
      totalHourStop
      motionStatus
    }
  }
}
`

export const GET_EMPLOYEE_UPLOAD_HISTORY = gql`
query ImportHistories($filter: ImportHistoriesFilter) {
  importHistories(filter: $filter) {
    isSuccessful
    message
    importHistories {
      users {
        fullname
      }
      importOn
      totalFailed
      totalSuccess
      model
      filename
    }
  }
}
`
